
<template>
  <div>
    <br/>
    <label for="birth">{{msg}}</label>
    <!-- <input id="birth" type="date" v-model="birthday" name="user_date" /> -->
    <el-date-picker
        v-model="birthday"
        type ="date"
        placeholder="what's your birthday?" @change='convert'>
    </el-date-picker>
    <br/>
    <br/> 
    <h1>{{ title }}</h1>
    <h2>可以选择过去的日期，或者是将来的日期，试试看哦</h2>
    <p class="container">
        更多育儿交流请关注微信公众号：kittybabycare（或搜索小猫咪育儿）      
    </p>
    <img src="../assets/qrcode.jpg">
    
    <!-- <button class="btn" @click='convert'>计算</button> -->
    <div class="hint">
    本站点承诺不会记录用户任何数据</div>
</div>
</template>

<script>
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");

const defaultTitle = "距离今天有?天"

export default {
  name: "EEC",
  props: {
    msg: String
  },
  data() {
    return {
      birthday: "",
      title: defaultTitle
    };
  },
  mounted() {},
  methods: {
    convert: function() {
      if (this.birthday) {
        var date1 = new Date(this.birthday);
        var date2 = new Date();
        var date3 = date1.getTime() - date2.getTime();
        var days = Math.floor(date3 / (24 * 3600 * 1000));
        if (date3 < 0) {
          this.title = `小宝贝来到世上已经${-days}天了`;
        } else {
          this.title = `距离今天还有${days}天`;
        }
      } else {
        this.title = defaultTitle;
      }
      return days;
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 0.6rem;
  padding: 0 0.2rem;
}
h2 {
  font-size: 0.32rem;
   margin-bottom: 1rem;
   padding: 0 1rem;
}
label {
  font-size: 0.34rem;
}
.btn {
  background-color: #3385ff;
  color: #fff;
  /* border-radius: 20%; */
  width: 100px;
  height: 40px;
}
.hint {
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  width: 100%;
  font-size: 0.28rem;
}
.container {
  font-size: 0.32rem;
}
img {
  width: 2rem;
}
</style>